class UserAuthenticateModel {
  /**
   * Constructor
   * @param {object} data
   */
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.email = data.email;
    this.roles = data.roles;
  }

  beautifyName() {
    if (typeof this.name !== 'undefined' && this.name !== null) {
      return this.name;
    }
    return this.email.substr(0, this.email.indexOf('@'));
  }
}

export default UserAuthenticateModel;
